import { ClusterLayer, type ClusterProps } from './cluster-layer'

export function ClustersLarge(props: ClusterProps) {
	return <ClusterLayer {...props} size="large" />
}
